// extracted by mini-css-extract-plugin
module.exports = {"noticeBoardMainWrap":"eO0TF","nbBadge":"lfsnV","textNodeWrap":"hP5Eq","nbBottomWrap":"YzSkD","fullText":"lvpeU"};